import { Controller } from "@hotwired/stimulus";

interface SelectActionEvent extends Event {
  params: { type?: string };
  currentTarget: HTMLElement;
}

export default class extends Controller<HTMLElement> {
  static targets = ["pillIcon", "pillLabel"];
  static values = { icons: Object };

  declare readonly pillIconTarget: HTMLElement;
  declare readonly pillLabelTarget: HTMLElement;
  declare readonly iconsValue: Record<string, string>;

  select(event: SelectActionEvent) {
    const newType = event.params.type;
    if (!newType) return;

    const hiddenSelect = this.findHiddenSelect();
    if (!hiddenSelect) return;
    if (newType === hiddenSelect.value) return;

    hiddenSelect.value = newType;
    hiddenSelect.dispatchEvent(new Event("change", { bubbles: true }));

    const newIcon = this.iconsValue[newType];
    if (newIcon) this.pillIconTarget.innerHTML = newIcon;

    const tile = event.currentTarget;
    const tileLabel = tile
      .querySelector(".text-sm.font-medium")
      ?.textContent?.trim();
    if (tileLabel) this.pillLabelTarget.textContent = tileLabel;
  }

  // The hidden <select> lives inside the surrounding <form>, but outside this
  // controller's element (the picker is in the form's header strip). Locate it
  // by walking up to the form and querying for the question_type field.
  private findHiddenSelect(): HTMLSelectElement | null {
    const form = this.element.closest("form");
    return (
      form?.querySelector<HTMLSelectElement>(
        'select[name*="[question_type]"]',
      ) ?? null
    );
  }
}
